<template>
  <div
    class="container bg-btn"
    :style="containerStyle"
    v-show="!isPlayerShow"
  >
    <span
      class="bg-btn__setting"
      v-show="false"
      @click="showPopup();report('setting')"
    >
      <i class="icon-bg-setting-gear"></i>
    </span>
    <span
      class="bg-btn__tip"
      ref="tip"
    >
      <div v-show="(!SelectSprites_Msg || !SelectSprites_Msg.length) && !isPlayerShow">
        <video-bg-duration ref="durationTip"></video-bg-duration>
      </div>
      <div>
        <loading
          v-if="isShowTip"
          v-show="SelectScenes_Msg.background && SelectScenes_Msg.background.data.type === 'Video'"
          ref="loadingTip"
        ></loading>
      </div>
      <div v-show="isShowUploadTip">
        <loading
          ref="uploadTip"
          :label="'正在上传GIF图'"
          :usage="'upload'"
          :percentStart="0"
          :msg="''"
        ></loading>
      </div>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tip from './bgSettingBtn/tip';
import videoBgDuration from './bgSettingBtn/duration';
import reporter from '@/components/mixins/analysis/sceneBgSetting';

export default {
  mixins: [reporter],
  data () {
    return {
      containerStyle: {
        top: '-9999px',
        left: '-9999px',
      },
      posInCanvas: {
        top: 18,
        left: 32
      },
      isPlayerShow: false,
      isShowTip: false,
      isShowUploadTip: false
    }
  },
  components: {
    loading: tip,
    videoBgDuration
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'ToolScroll_Size',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
    ...mapGetters({
      openSubtitle: 'subtitle/openSubtitle'
    }),
  },
  watch: {
    openSubtitle (val) {
      if (!val) {
        this.containerStyle = {
          opacity: 0
        };
        setTimeout(() => {
          this.initContainerStyle();
        }, 1000);
      }
    },
    'TOOL.PfixLeft': {
      handler () {
        this.initContainerStyle();
      }
    },
    'TOOL.PfixTop': {
      handler () {
        this.initContainerStyle();
      }
    },
    'TOOL.player.ele': {
      handler (val) {
        this.observe(val[0])
      }
    },
    'TOOL.scale': {
      handler () {
        $('#app .Tool .mask-blur')
          .css({
            backgroundSize: `${this.TOOL.clientWidth}px ${this.TOOL.clientHeight}px`
          });
      }
    }
  },
  created () {
    eve.on('sceneBgAdded', (scene, { spriteType, update, isShowLoading } = {}) => {
      const vm = this;
      let bgType = scene.background.data.type;
      if (bgType != 'Video' || spriteType != 'background' || update) {
        return;
      }
      let video = scene.background.element.playerVideo[0];
      if (!video) {
        return;
      }

      // let contentVideo = scene.background.element.contentVideo[0];
      // contentVideo && contentVideo.addEventListener('canplaythrough', function h () {
      //   // contentVideo.currentTime = scene.nowTime % contentVideo.duration;
      //   scene.syncVideoBgTime();
      //   contentVideo.removeEventListener('canplaythrough', h);
      // });

      if (isShowLoading) {
        this.isShowTip = true;
        video.addEventListener('canplaythrough', function handler () {
          vm.$refs.loadingTip && vm.$refs.loadingTip.setComplete()
            .then(() => {
              setTimeout(() => {
                vm.isShowTip = false;

                // show duration tip
                vm.$refs.durationTip && vm.$refs.durationTip.render();
              }, 1000);
            })

          video.removeEventListener('canplaythrough', handler);
        });
      }

      // $(`[data-url^="${video.dataset.url}"]`).each((i, el) => {
      //   vm.checkVideoLoad(video);
      // });

      // this.TOOL.eve.on('loadBgError', ({ type } = {}) => {
      //   if (type === 'Video') {
      //     this.isShowTip = false;
      //   }
      // })
    });

    // this.$bus.on('spriteAdded', (scene) => {
    //   if (scene.background.data.type !== 'Video') {
    //     vm.$refs.durationTip.isVideoBg = false;
    //   }
    // })

    this.$bus.on('upload.progress', ({
      percent = 0,
      file
    } = {}) => {
      if (!/\.(?:gif|GIF)$/.test(file.name)) {
        return;
      }
      // console.log({percent})
      if (!this.$refs.uploadTip) {
        return;
      }

      if (percent > 0) {
        this.isShowUploadTip = true;
        this.$refs.uploadTip.setPercent(percent | 0);
      }

      if (percent === 100) {
        this.$refs.uploadTip.setComplete()
          .then(() => {
            setTimeout(() => {
              this.isShowUploadTip = false;
            }, 1000);
          })
      }
    });

    this.$bus.on('zoomOptions.openPopups', (popup) => {
      setTimeout(() => {
        let prevPopup = popup.boxData.data.source
        this.showPopup();
        // popup.boxData.judgeBox = true;
        if (prevPopup) {
          // prevPopup.boxData.judgeBox = true;
          prevPopup.isShowMask = true;
          this.$nextTick(() => {
            prevPopup.openChild({
              name: 'zoom'
            });
            popup.isShowZoomScaleMenu = true;
          })
        }
      }, 50);
    });
  },
  mounted () {
    this.initContainerStyle();
  },
  methods: {
    initContainerStyle () {
      let { $el, TOOL: tool, posInCanvas, ToolScroll_Size: toolScroll } = this;
      let { PfixLeft: canvasLeft, PfixTop: canvasTop } = tool;
      let offsetParent = $el.offsetParent;
      if (!offsetParent) {
        return;
      }
      let rect = offsetParent.getBoundingClientRect();
      // let dx = canvasLeft - rect.left;
      // let dy = canvasTop - rect.top;
      let positionBase = this.getPositionBase();
      let posRect = positionBase.getBoundingClientRect();
      if (!this.TOOL.contentBody) {
        return;
      }
      let altPosRect = this.TOOL.contentBody[0].getBoundingClientRect();
      let baseLeft = Math.max(posRect.left, altPosRect.left);
      this.containerStyle = {
        // top: (dy + posInCanvas.top + toolScroll.top) + 'px',
        // left: (dx + posInCanvas.left + toolScroll.left) + 'px'
        top: (- rect.top + posRect.top + posInCanvas.top) + 'px',
        left: (- rect.left + baseLeft + posInCanvas.left) + 'px'
      }
      this.$nextTick(() => {
        this.setTipStyle({});
      })
    },
    setTipStyle ({
      top,
      left
    } = {}) {
      let { tip } = this.$refs;
      let { ToolScroll_Size: toolScroll } = this;
      let positionBase = this.getPositionBase();
      let old = tip.style.display;
      tip.style.opacity = 0;
      tip.style.display = '';
      tip.style.top = (positionBase.offsetHeight - this.posInCanvas.top - tip.offsetHeight - 4) + 'px';
      tip.style.left = (0 - this.posInCanvas.left + 4) + 'px';

      tip.style.display = old;
      tip.style.opacity = '';
    },
    showPopup () {
      let { $el } = this;
      let rect = $el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        // name: 'setting_Bg',
        name: 'bgPopup',
        type: 1,
        initialX: rect.left + 80,
        initialY: rect.top,
      });
    },
    observe (element) {
      const vm = this;
      const callback = function (records) {
        vm.isPlayerShow = element.style.display !== 'none'
      };

      const mo = new MutationObserver(callback);

      const options = {
        'attributes': true,
        'attributeOldValue': true
      }

      mo.observe(element, options);
    },
    isScrollActive (scrollContainer) {
      let sy = scrollContainer.querySelector('.scroll-dragger.scroll-y');
      let sx = scrollContainer.querySelector('.scroll-dragger.scroll-x');
      return {
        bool: sy && sy.style.display !== 'none'
          || sx && sx.style.display !== 'none',
        sy,
        sx,
      }
    },
    getPositionBase () {
      let scrollContainer = document.body.querySelector('.scroll-visible');
      let { bool: isScrollActive } = this.isScrollActive(scrollContainer);
      if (isScrollActive) {
        return scrollContainer;
      } else {
        try {
          return this.TOOL.contentBody[0];
        } catch (err) {
          return document.createElement('div');
        }
      }
    },
    checkVideoLoad (video) {
      const vm = this;
      let acc = 0;
      video.addEventListener('error', function handleErr (ev) {
        console.log({ ev, acc, video, err: video.error })
        acc += 1;
        if (acc >= 3) {
          video.removeEventListener('error', handleErr);
          vm.isShowTip = false;
          if (!$(".error-toast-videoBg").length) {
            vm.$message({
              // message: '视频背景加载失败，请检查网络',
              message: '网络出问题啦~请重新再试',
              type: 'error',
              customClass: "error-toast-videoBg"
            });
          }

          vm.SelectScenes_Msg.setBackground({  // 设置场景背景
            resourceId: null,      // 背景资源id
            fileType: null,        // 背景资源type
            type: 'Color',                                           // 背景类型 0:Color 1:Image 2:Video
            data: {                                            // 颜色背景的数据
              color: '#ffffff',                                    // 颜色值,8位数
              blur: 0,                                           // 高斯模糊
              opacity: 1,                                            // 高斯模糊参数
            },
          }, null, false);
          return;
        }

        video.load();

      });
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-btn {
  position: absolute;
  z-index: 130;
  width: 0;
  height: 0;

  &__setting {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -9px;
    left: -22px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    background-color: rgba(#000, 0.3);
    border-radius: 4px;
  }

  &__tip {
    position: absolute;
    min-height: 36px;

    > div {
      position: absolute;
      left: 0;
      bottom: 0;
    }
    // padding: 10px;
    // background-color: rgba(#000, 0.5);
    // border-radius: 4px;
    // color: white;
    // white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/bgSettingBtn.vue